import script from "./chart8.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart8.vue?vue&type=script&lang=ts&setup=true"

import "./chart8.vue?vue&type=style&index=0&id=605e0eb5&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605e0eb5"]])

export default __exports__